<template>
<!-- 专家库 -->
  <div class="page-container">
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        :size="size"
      >
        <el-form-item>
          <kt-button icon="el-icon-plus" label="新增" type="primary" @click="handleAdd" />
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-refresh" label="刷新" type="primary" @click="handleRefresh" />
        </el-form-item>
      </el-form>
      <div class="filtersposition"></div>
    </el-scrollbar>
    <!--表格内容栏-->
    <kt-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      :data="pageResult"
      :columns="filterColumns"
      :operationWidth="200"
      :cellStyle="cellStyle"
      :showEdit="true"
      :showDelete="true"
      :showLook="false"
      @refreshPageRequest="refreshPageRequest"
      @findPage="findPage"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @cellClick="cellClick"
    ></kt-table>


    <!-- 新增服务人员和修改服务人员的dialog模态框-->
    <el-dialog
      :title="operation?'新增专家':'修改专家'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="closeDialogReset"
      center
    >
      <el-form
        :model="dataForm"
        label-width="170px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right">
        <el-row>
          <el-form-item label="姓名:" required>
            <el-select :disabled="!operation" v-model="dataForm.staffId" placeholder="请选择服务人员" style="width:350px">
              <el-option
                v-for="item in serverList"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医院:">
              <el-input v-model.trim="dataForm.hospital" maxlength="15" auto-complete="off" placeholder="请输入医院" style="width:350px"></el-input>
          </el-form-item>
          <el-form-item label="科室:">
              <el-input v-model.trim="dataForm.administrative" maxlength="15" auto-complete="off" placeholder="请输入科室" style="width:350px"></el-input>
          </el-form-item>
          <el-form-item label="擅长:">
              <el-input v-model.trim="dataForm.speciality" maxlength="25" auto-complete="off" placeholder="请输入擅长内容" style="width:350px"></el-input>
          </el-form-item>
          <el-form-item label="咨询价格:" required>
            <el-input-number v-model.trim="dataForm.consultPrice" :precision="2" style="width:350px"
              controls-position="right" :min="0" :max="9999" placeholder="请输入咨询价格">
            </el-input-number>
            <div class="unit">元/次</div>
          </el-form-item>
          <el-form-item label="视频通话包月价格:" required>
            <el-input-number v-model.trim="dataForm.videoPrice"  style="width:350px"
              controls-position="right" :min="0" :max="9999" :precision="2"
              auto-complete="off" placeholder="请输入视频通话包月价格">
            </el-input-number>
            <div class="unit">元/月</div>
          </el-form-item>
          <el-form-item label="视频通话每月次数:" required>
              <el-input-number v-model.trim="dataForm.numberMonthly" 
                style="width:350px"
                controls-position="right" :min="1" :max="999"
                placeholder="请输入视频通话每月次数上限"
                @input.native="onInput0_100" 
                onKeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))">
              </el-input-number>
              <div class="unit">次</div>
          </el-form-item>
          <el-form-item label="单次咨询专家提成:" required>
              <el-input-number v-model.trim="dataForm.consultProportion"  style="width:350px"
              controls-position="right" :min="0" :max="100" :step-strictly="true"
              auto-complete="off" placeholder="请输入单次咨询专家提成">
              </el-input-number>
              <div class="unit">%</div>
          </el-form-item>
          <el-form-item label="视频通话包月专家提成:" required>
              <el-input-number v-model.trim="dataForm.videoProportion"  style="width:350px"
              controls-position="right" :min="0" :max="100" :step-strictly="true"
              auto-complete="off" placeholder="请输入视频通话包月专家提成">
              </el-input-number>
              <div class="unit">%</div>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisible = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="上下线设置"
      :visible.sync="dialogupdownVisible"
      label-width="100px"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" label-width="70px">
          <el-form-item label="上下线">
             <el-radio v-model="undown" class="dowmup" label="1">上线</el-radio>
            <el-radio v-model="undown" class="dowmup" label="0">下线</el-radio>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
          <el-button :size="size" @click.native="dialogupdownVisible = false">取消</el-button>
          <el-button :size="size" type="primary" @click.native="undowmSubmit" >确定</el-button>
      </div>

    </el-dialog>

     <!-- 查看上下线的dialog模态框 -->
    <el-dialog
      :title="personnelTitle"
      :visible.sync="upDownRecordDialogVisible"
      width="40%"
      :center="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      >
      <span>
      <el-table :data="upDownRecordList" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
        <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
        <el-table-column prop="statusChangeTime" label="状态变更时间" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
           <template slot-scope="scope">
            <span v-if="scope.row.status==1" style="color:green;">在线</span>
            <span v-else style="color:red">离线</span>
        </template>
        </el-table-column>
      </el-table>
       <!-- 分页 -->
        <el-pagination
          background
          layout="total,prev, pager, next,jumper"
          :total="recordTotal"
          style="margin-top:20px"
          align="center"
          class="fenye"
          @current-change="recordChangePage"
          :current-page="logPageNum"
        ></el-pagination>

      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upDownRecordDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  components: {
    KtTable,
    KtButton
  },
  data() {
    return {
      filePic: "", //图片文件
      id: "", //重置密码需要的id
      loading: true,
      professionOptions: [], //职业类型
      size: "medium", //按钮的尺寸
      dialogupdownVisible:false,
      filters: {
      },
      columns: [], //table列的集合
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 }, //默认分页
      pageResult: {},
      dataForm: {
      }, //新增和修改
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false, //修改loading
      updownform:{}, //上下线
      serverList:[],
      undown:0,
      undowmId:'',
      //服务人员上下线记录的dialog模态框
      upDownRecordDialogVisible:false,
      personnelTitle:"人员上下线记录",
      logPageNum:1,
      logId:'',
      recordTotal:0,
      upDownRecordList:[
        
      ],//服务人员上下线集合
      dataFormRules: {
        
      },
      codeDataForm: {}, //重置密的form表单数据
      dialogVisibleCode: false, //重置密码的dialog显示和隐藏
      codeLoading: false, //重置密码的loading
      codeDataFormRules: {
        password: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符"
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" }
        ],
        confirmPwd: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符"
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" }
        ]
      },
      pickerBirthday: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      groupId:"",
      submitDisabled:true,
      //服务人员上下线记录的分页
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      totalDataNumber:0,//总条数
    };
  },
  methods: {
    getServcerList(){
      var params = {
        groupId :this.groupId,
        pageNum:1,
        pageSize:1000,
      }
      this.$postJson("uac/staff/selectStaffByNotSpecoalist",params).then(res =>{
        console.log(res);
        this.serverList = res.result.list;
      })
    },
    onInput0_100(e) {
        this.$message.closeAll();
        // 验证是否是纯数字
        let isNumber = /^\d*$/.test(e.target.value);
        // 过滤非数字
        e.target.value = e.target.value.replace(/\D/g, "");
        if (!isNumber || e.target.value < 0 || e.target.value > 999) {
          this.$message.warning("只能输入[1,999]区间的整数");
        }
        e.target.value = (e.target.value >= 0 && e.target.value <= 999 && e.target.value.match(/^\d*/g)[0]) || null;
    },
    undowmSubmit(){
      //上下线设置弹出enter
      var params = {
        id:Number(this.undowmId)
      }
      var url = "";
      if(this.undown == 1){
          url = "omc/specialist/on";
      }else{
          url = "omc/specialist/off";
      }
      this.$postForm(url,params).then(res =>{
        this.dialogupdownVisible = false;
        this.findPage();  
      })

    },
    //清除校验
    clearValidate(formName) {
      //formName为传入要清除的prop ，可以是整个form表单，也可以是一个
      this.$refs[formName].clearValidate();
    },
    // 刷新
    handleRefresh() {
      this.filters = {}; //清空查询条件
      this.findPage();
    },
     // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },
        /* 
      修改单元格的字体颜色
    */
    cellStyle( { row, column, rowIndex, columnIndex }) {
      if(column.label=='上下线状态') {
        if(row.isPutaway != 0){
          return "color: red";
        }else{
          return "color:green";
        }
      }
    },
    //关闭新增和修改服务人员的dialog清除验证
    closeDialogReset() {
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
    },
    // 获取分页数据
    findPage(data) {
      this.pageRequest.groupId = this.groupId;
      this.$postJson("omc/specialist/select", this.pageRequest)
        .then(res => {
          console.log(res.result);
          res.result.list.forEach(item => {
            item.gender == 0 ? (item.gender = "男") : (item.gender = "女");
            item.isPutaway != 0 ? (item.status='离线'):(item.status='在线');
          });
          this.pageResult = res.result; //将值赋给this.pageResult这个对象
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },
    handleUpDown(data){
      this.dialogupdownVisible = true;
      this.undown = ''+data.row.isPutaway;
      this.undowmId = data.row.id;

    },
    // 删除
    handleDelete(data) {
      console.log(data.params[0].id, data.callback);
      let staffId = data.params[0].id;
      console.log(staffId);
      this.$postForm("omc/specialist/delete",{
        id:staffId
      }).then(res => {
        console.log(res);
        var info = res;
        data.callback(info);
      });
    },
    // 显示新增界面
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
      this.submitDisabled=true;
      this.dataForm = {
      };
      this.$nextTick(() => {
        if (this.$refs.dataForm != undefined) {
          this.$refs.dataForm.resetFields();
        }
      });
      this.getServcerList();
    },
    // 显示编辑界面
    handleEdit(params) {
      this.dialogVisible = true;
      this.operation = false;
      this.$nextTick(() => {
        this.dataForm = Object.assign({}, params.row);
        this.dataForm.staffId = this.dataForm.specialistName;
      });
      
      this.getServcerList();
    },

    // 新增和编辑提交数据
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          if(this.dataForm.staffId == '' || this.dataForm.staffId == undefined){
            this.$message({message: "请选择服务人员",type: "error"});
            return;
          }
          if(this.dataForm.consultPrice === '' || this.dataForm.consultPrice == undefined){
            this.$message({message: "请输入咨询价格",type: "error"});
            return;
          }
          if(this.dataForm.videoPrice === '' || this.dataForm.videoPrice == undefined){
            this.$message({message: "请输入视频通话包月价格",type: "error"});
            return;
          }
          if(this.dataForm.numberMonthly == '' || this.dataForm.numberMonthly == undefined){
            this.$message({message: "请输入视频通话每月次数上限",type: "error"});
            return;
          }if(this.dataForm.consultProportion == '' || this.dataForm.consultProportion == undefined){
            this.$message({message: "请输入单次咨询专家提成",type: "error"});
            return;
          }
          if(this.dataForm.videoProportion == '' || this.dataForm.videoProportion == undefined){
            this.$message({message: "请输入视频通话包月专家提成",type: "error"});
            return;
          }

          this.editLoading = true;
          let params = Object.assign({}, this.dataForm);
          var serverList = this.serverList;
          params.videoPrice = Number(params.videoPrice);
          params.numberMonthly = Number(params.numberMonthly);
          params.consultPrice = Number(params.consultPrice);
          if(this.operation){
            params.staffId = Number(params.staffId);
            for(var i=0;i<serverList.length;i++){
              if(params.staffId == serverList[i].id){
                params.gender = serverList[i].gender;
                params.age = serverList[i].age;
                params.staffUserId = serverList[i].userId;
                params.specialistName = serverList[i].userName;
                params.imgsCode = serverList[i].headerPic;
                params.loginName = serverList[i].loginName;
                console.log(serverList[i]);
                break;
              }
            }
          }else{
            params = {
              id:params.id,
              specialistName:params.specialistName,
              gender:params.gender == '男'?0:1,
              age:params.age,
              hospital:params.hospital,
              administrative:params.administrative,
              imgsCode: params.imgsCode,
              speciality:params.speciality,
              loginName:params.loginName,
              consultPrice:Number(params.consultPrice),
              numberMonthly:Number(params.numberMonthly),
              videoPrice:Number(params.videoPrice),
              consultProportion:Number(params.consultProportion),
              videoProportion:Number(params.videoProportion)
            }
          }
          params.consultRoyalty = params.consultProportion * params.consultPrice / 100
          params.videoRoyalty = params.videoProportion * params.videoPrice / 100
          console.log(this.operation, params);
          //this.operation==true为新增的url  this.operation==false为修改的url
          let url = "";
          if(this.operation){
            url = "omc/specialist/add";
            params.groupId=this.groupId;
          }else{
            url = "omc/specialist/update"
          }
          console.log(url);
          this.$postJson(url, params).then(res => {
            console.log(res);
            this.editLoading = false;
            if (res.code == 200) {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisible = false;
              this.$refs["dataForm"].resetFields();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error"
              });
            }
            this.findPage();
          });
        }
      });
    },
    recordChangePage(val){
      console.log(val);
      this.logPageNum = val;
      var params = {
            staffId:this.logId,
            pageSize:10,
            pageNum:this.logPageNum
      }
      this.$postJson("uac/staff/getStatusLog",params).then(res =>{
          this.upDownRecordList = res.result.list;
          this.recordTotal =  Number(res.result.total)
      })
    },
      //上下线记录
    cellClick(data) {
      //点击的column label为 上下线记录才弹出人员上下线记录的模态框
      if(data.column.label=='上下线状态'){
        console.log(data,data.row.id);
        var id = data.row.id;
        this.logId = data.row.id;
        // var id = data.row.userId;
        this.upDownRecordDialogVisible=true;
        // uac/staff/getStatusLog
       var params = {
            staffId:id,
            pageSize:10,
            pageNum:this.logPageNum
        }
        this.$postJson("uac/staff/getStatusLog",params).then(res =>{
          this.upDownRecordList = res.result.list;
          this.recordTotal =  Number(res.result.total);
        })
      }
    },
     /* 
      修改table tr行的背景色
    */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    /* 
      修改table header的背景色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
     if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
    // 时间格式化
    dateFormat: function(row, column, cellValue, index) {
      return format(row[column.property]);
    },
    // 处理表格列过滤显示
    displayFilterColumnsDialog: function() {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true);
    },
    // 处理表格列过滤显示
    handleFilterColumns: function(data) {
      this.filterColumns = data.filterColumns;
      this.$refs.tableColumnFilterDialog.setDialogVisible(false);
    },
    // 处理表格列过滤显示
    initColumns: function() {
      this.columns = [
        { prop: "specialistName", label: "姓名", minWidth: 100 },
        { prop: "gender", label: "性别", minWidth: 80 },
        { prop: "age", label: "年龄", minWidth: 80 },
        { prop: "speciality", label: "擅长", minWidth: 120 },
        { prop: "hospital", label: "医院", minWidth: 120 },
        { prop: "administrative", label: "科室", minWidth: 120 },
        { prop: "consultPrice", label: "咨询价格", minWidth: 100 },
        { prop: "videoPrice", label: "视频包月价格", minWidth: 120 },
        { prop: "numberMonthly", label: "视频通话次数上限", minWidth: 150 },
        { prop: "consultProportion", label: "单次咨询专家提成", minWidth: 150 },
        { prop: "videoProportion", label: "视频通话包月专家提成", minWidth: 150 },
        { prop: "loginName", label: "登录账号", minWidth: 100 },
        { prop: "status", label: "上下线状态", minWidth: 100 },
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },

  },
  created() {
    this.groupId=sessionStorage.getItem('groupId');
  },
  mounted() {
    this.initColumns();
    this.findPage();
  }
};
</script>

<style lang="scss" scoped>
.rz-picter {
  width: 100%;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.rz-picter:hover {
  border-color: #409eff;
}
.img-avatar {
  width: 140px;
  height: 140px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.uppic {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: 0;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增 编辑 dialog
@media screen and (max-width: 1599px) {
  ::deep .volunteerdialog .el-dialog {
    width: 80% !important;
  }
}
::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  width: 100.5%;
  height: 100%;
}
::deep .el-form--inline {
  position: relative;
  z-index: 99;
}
.dowmup{
  margin-top: 12px;
  margin-right: 20px;
  margin-left: 20px;
}
.filtersposition {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100%;
  height: 56px;
  background: #f2f2f2;
  z-index: 1;
}
.unit{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 90px;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>